import Vue from 'vue'
import VueRouter from 'vue-router'
import wx from 'weixin-js-sdk'
import toast from '@/components/toast'
import {isWechatMiniProgram} from '../utils/device'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: 'shop',
      path: '/shop'
    },
    {
      name: 'error',
      path: '/error',
      component: r => require.ensure([], () => r(require('@/views/error')), 'error')
    },
    {
      name: 'index',
      path: '/',
      component: r => require.ensure([], () => r(require('@/views/index')), 'index')
    },
    {
      name: 'huichang',
      path: '/huichang',
      component: r => require.ensure([], () => r(require('@/views/huichang')), 'huichang')
    },
    {
      name: 'performs',
      path: '/performs/:performId',
      component: r => require.ensure([], () => r(require('@/views/performs')), 'performs')
    },
    {
      name: 'actor-detail',
      path: '/actor-detail/:actorId',
      component: r => require.ensure([], () => r(require('@/views/actor-detail')), 'actor-detail')
    },
    {
      name: 'modify',
      path: '/modify',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/user/modify')), 'user')
    },
    {
      name: 'events',
      path: '/events',
      component: r => require.ensure([], () => r(require('@/views/events')), 'event')
    },
    {
      name: 'login',
      path: '/login',
      component: r => require.ensure([], () => r(require('@/views/user/login')), 'user')
    },
    {
      name: 'register',
      path: '/register',
      component: r => require.ensure([], () => r(require('@/views/user/register')), 'user')
    },
    {
      name: 'findPassword',
      path: '/find-password',
      component: r => require.ensure([], () => r(require('@/views/user/findPassword')), 'user')
    },
    {
      name: 'modifyPassword',
      path: '/modify-password',
      component: r => require.ensure([], () => r(require('@/views/user/modifyPassword')), 'user')
    },
    {
      name: 'schedules',
      path: '/schedules',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/schedules')), 'schedules')
    },
    {
      name: 'series',
      path: '/series/:seriesId',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/series')), 'series')
    },
    {
      name: 'news',
      path: '/news',
      component: r => require.ensure([], () => r(require('@/views/news')), 'news')
    },
    {
      name: 'news-detail',
      path: '/news/:newsId',
      component: r => require.ensure([], () => r(require('@/views/news-detail')), 'news-detail')
    },
    {
      name: 'my',
      path: '/my',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/my')), 'my')
    },
    {
      name: 'myTickets',
      path: '/my-tickets',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/my-tickets')), 'order')
    },
    {
      name: 'myCoupons',
      path: '/my-coupons',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/my-coupons')), 'my')
    },
    {
      name: 'couponDetail',
      path: '/coupon-detail',
      component: r => require.ensure([], () => r(require('@/views/coupon-detail')), 'coupon-detail')
    },
    {
      name: 'orderConfirm',
      path: '/order-confirm',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/order-confirm')), 'order-confirm')
    },
    {
      name: 'orderDetail',
      path: '/order-detail',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/order-detail')), 'order')
    },
    {
      name: 'memberCenter',
      path: '/member-center',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/member-center')), 'member-center')
    },
    {
      name: 'memberRights',
      path: '/member-rights',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/agreement/member-rights')), 'member-rights')
    },
    {
      name: 'memberAgreement',
      path: '/member-agreement',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/agreement/member-agreement')), 'agreement')
    },
    {
      name: 'serviceAgreement',
      path: '/service-agreement',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/agreement/service-agreement')), 'agreement')
    },
    {
      name: 'privacyPolicy',
      path: '/privacy-policy',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/agreement/privacy-policy')), 'agreement')
    },
    {
      name: 'memberInfo',
      path: '/member-info',
      meta: {
        bgColor: true
      },
      component: r => require.ensure([], () => r(require('@/views/member-info')), 'member-info')
    },
    {
      name: 'seat',
      path: '/seat/:sessionId',
      component: r => require.ensure([], () => r(require('@/views/seat')), 'seat')
    },
    {
      name: 'about',
      path: '/about',
      component: r => require.ensure([], () => r(require('@/views/about/intro')), 'about')
    },
    {
      name: 'siteFacilities',
      path: '/site-facilities',
      component: r => require.ensure([], () => r(require('@/views/about/site-facilities')), 'site-facilities')
    },
    {
      name: 'partner',
      path: '/partner',
      component: r => require.ensure([], () => r(require('@/views/about/partner')), 'partner')
    },
    {
      name: 'faq',
      path: '/faq',
      component: r => require.ensure([], () => r(require('@/views/faq')), 'faq')
    },
    {
      name: 'faqDetail',
      path: '/faq-detail/:faqId',
      component: r => require.ensure([], () => r(require('@/views/faq-detail')), 'faq-detail')
    },
    {
      name: 'error-message',
      path: '/error-message/:msgId',
      component: r => require.ensure([], () => r(require('@/views/error-message')), 'error-message')
    },
    {
      name: 'event201811',
      path: '/event201811',
      component: r => require.ensure([], () => r(require('@/views/lecture')), 'event')
    },
    {
      name: 'eventGuest',
      path: '/event-guest',
      component: r => require.ensure([], () => r(require('@/views/event-guest')), 'event')
    }, /*
    {
      name: 'eventGuest0626',
      path: '/event-guest-0626',
      component: r => require.ensure([], () => r(require('@/views/event-guest-0626')), 'event')
    }, */
    {
      name: 'eventMember',
      path: '/event-member',
      component: r => require.ensure([], () => r(require('@/views/event-member')), 'event')
    },
    {
      name: 'eventStudy',
      path: '/event-study',
      component: r => require.ensure([], () => r(require('@/views/event-study')), 'event')
    },
    {
      name: 'eventInfoMember',
      path: '/event-info-member/:sessionId',
      component: r => require.ensure([], () => r(require('@/views/event-info-member')), 'event')
    },

    {
      name: 'ticketExpress',
      path: '/ticket-express',
      component: r => require.ensure([], () => r(require('@/views/ticket-express')), 'event')
    },
    {
      name: '1108Express',
      path: '/1108-express',
      component: r => require.ensure([], () => r(require('@/views/1108-express')), 'event')
    },

    {
      name: 'announceRecruit',
      path: '/announce-recruit',
      component: r => require.ensure([], () => r(require('@/views/announce-recruit')), 'error-message')
    },
    {
      name: 'refund-account',
      path: '/refund-account',
      component: r => require.ensure([], () => r(require('@/views/refund-account')), 'member-info')
    },
    {
      name: 'voucher-submit',
      path: '/voucher-submit',
      component: r => require.ensure([], () => r(require('@/views/voucher-submit')), 'member-info')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.afterEach(route => {
  const meta = route.meta || {}
  const bodyClass = document.body.classList
  if (meta.bgColor) {
    bodyClass.add('bgColor')
  } else {
    bodyClass.remove('bgColor')
  }
  document.title = meta.title || '上剧场'
})
router.afterEach((to, from) => {
  if (from.path === '/login' && to.query.scene === 'login-success') {
    toast.show('登录成功', {
      duration: 1000
    })
  }
  if (from.path === '/order-confirm' && to.query.scene === 'pay-success') {
    toast.show('订购成功', {
      duration: 1000
    })
  }
})
// 小程序 web-view 内：每次路由变化上报当前路径与标题，标题异步变化时也补报，供小程序分享深链使用
let titleObserverStarted = false
router.afterEach(to => {
  if (!isWechatMiniProgram()) {
    return
  }
  wx.miniProgram.postMessage({
    data: {
      type: 'route',
      path: to.fullPath,
      title: document.title
    }
  })
  if (!titleObserverStarted) {
    titleObserverStarted = true
    const titleEl = document.getElementsByTagName('title')[0]
    if (titleEl) {
      new MutationObserver(() => {
        wx.miniProgram.postMessage({
          data: {
            type: 'title',
            title: document.title
          }
        })
      }).observe(titleEl, {childList: true, characterData: true, subtree: true})
    }
  }
})
router.afterEach((to, from, next) => {
  setTimeout(() => {
    // var _hmt = _hmt || [];
    (function () {
      // 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove()
      document.getElementById('sjcstat') && document.getElementById('sjcstat').remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?e87a6a16bc32c9539d735aecfa673e59'
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
      if (to.meta.userId === '' || to.meta.userId) {
        var k1 = (to.query.k1) ? to.query.k1 : ''
        var k2 = (to.query.k2) ? to.query.k2 : ''
        var src = 'https://stat.theatreabove.com/r.php?m=' + to.meta.userId + '&src=M&k1=' + k1 + '&k2=' + k2 + '&url=' + encodeURIComponent(location.pathname + location.search) + '&ref=' + encodeURIComponent(document.referrer)
        if (isWechatMiniProgram()) {
          src = 'https://stat.theatreabove.com/r.php?m=' + to.meta.userId + '&src=MP&k1=' + k1 + '&k2=' + k2 + '&url=' + encodeURIComponent(location.pathname + location.search) + '&ref=' + encodeURIComponent(document.referrer)
        }
        var stat = document.createElement('img')
        stat.src = src
        stat.id = 'sjcstat'
        s.parentNode.insertBefore(stat, s)
      } else {
        console.log('nuid')
      }
    })()
  }, 0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js